import { UserRole } from '../types/auth.types';

// ONE mapping from the roles array to the coarse UI tier stored as `user.role`
// (header chip, nav). Accepts both raw DB names (admin, tenant_admin) and
// normalized claim names (tenant_owner) because login responses carry raw roles
// while /auth/session carries normalized ones — the two sources must never
// derive different tiers for the same person. UI-only: backend authorization
// always comes from verified token claims, never from this value.
const ADMIN_ROLES = new Set(['admin', 'tenant_admin', 'tenant-admin', 'tenant_owner']);
const MANAGER_ROLES = new Set(['manager', 'team_lead']);

export function deriveCoarseRole(roles: string[] | undefined | null): UserRole {
  const list = Array.isArray(roles) ? roles : [];
  if (list.some((r) => ADMIN_ROLES.has(r))) return UserRole.ADMIN;
  if (list.some((r) => MANAGER_ROLES.has(r))) return UserRole.MANAGER;
  return UserRole.EMPLOYEE;
}
